import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-19cd91f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-auto-monitor" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title f-size-24 f-col-white08" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "descriptions-item point" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "主要超标污染物:", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "newest-parameter" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "parameter" }
const _hoisted_11 = { class: "parameter-box" }
const _hoisted_12 = { class: "box-content" }
const _hoisted_13 = { class: "key" }
const _hoisted_14 = { class: "echart" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "body" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import Bus from '@/config/Bus'
import AutoMonitor from '../charts/AutoMonitor.vue'
import StationPhotoDialog from '@/components/Dialog/StationPhotoDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogAutoMonitor',
  props: {
  data: Object,
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const api = new Api()
const props = __props
const emit = __emit

const autoMonitor = ref()
const options = []
const selectFactor = ref({})
const echartTime = ref('H')
const startTime = ref(new Date().getTime())
startTime.value = props.data.dataTime
  ? new Date(props.data.dataTime).getTime()
  : new Date().getTime()
const parameter = {
  title: '',
  data: [],
}
const model: any = ref(null)
// 模型预测
const toModel = () => {
  Bus.emit('showModal3')
}
const select = async (val) => {
  switch (val) {
    case 'H':
      echartTime.value = 'H'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    case 'D':
      echartTime.value = 'D'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    default:
      selectFactor.value = val
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName, {
      //   standValues: val.standValues,
      //   unit: val.unit,
      // });
      break
  }
}
const getFontSize = (value: any) => {
  let className = ''
  let val = value
  if (!value) {
    return className
  }
  if (typeof value === 'number') {
    val = `${value}`
  }
  if (val.length < 6) {
    className = 'font-size48'
  } else if (val.length < 10) {
    className = 'font-size40'
  } else {
    className = 'font-size34'
  }
  return className
}
// 获取echart趋势数据
const getTrend = async () => {
  let data = []
  await api.screen
    .getMonitorDataListUsingGet({
      begin: format(startTime.value),
      factor: selectFactor.value.factorCode,
      frequency: echartTime.value,
      mn: props.data.id,
    })
    .then((res) => {
      if (res.code == 200) {
        data = res.data
      }
    })
  const XData = []
  const YData = []
  for (let i = 0; i < data.length; i += 1) {
    XData.push(data[i].dataTime)
    YData.push(data[i].value)
  }
  // console.log(selectFactor.value)
  const markLine = {
    datumLine: selectFactor.value.standValues ? selectFactor.value.standValues[0] : null,
    unit: selectFactor.value.unit,
  }
  autoMonitor.value.initChart(XData, YData, selectFactor.value.factorName, markLine)
}
const getYzCbBs = (array: any[]) => {
  let res = '无'
  if (array && array.length) {
    res = ''
    array.forEach((item, index) => {
      if (index + 1 < array.length) {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}），`
      } else {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}）`
      }
    })
  }
  return res
}

const stationDialog = ref(null)
// TODO查看湾凼现场照片
const checkSitePhoto = (e: any) => {
  e.preventDefault()
  console.log(stationDialog.value, 'checkSitePhoto')
  if (stationDialog.value) {
    stationDialog.value.open()
  }
}

// 污染溯源
const traceSource = () => {
  console.log('数据aaa', props.data)
  emit('close')
  const data1 = {
    ...props.data,
  }
  Bus.emit('mapClick', {
    data: { ...data1, selectFactor: selectFactor.value.factorName },
    modalType: '污染溯源',
  })
}
const changeTime = () => {
  getTrend()
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  // getTrend()
  select(props.data.factorList[0])
})

return (_ctx: any,_cache: any) => {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.data.name) + " ", 1),
        (__props.data.name === '湾凼')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              onClick: checkSitePhoto
            }, "(现场照片)"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "btn",
        onClick: traceSource
      }, "污染溯源"),
      _createElementVNode("div", {
        class: "btn btn-model",
        onClick: toModel
      }, " 模型预测 ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(getYzCbBs(__props.data.zywrwList)), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, " 最新水质参数（" + _toDisplayString(__props.data.dataTime ? __props.data.dataTime : '-') + "）： ", 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.dataList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "data-box"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", getFontSize(item.monitorValue)])
                  }, _toDisplayString(item.monitorValue), 3),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.factorName), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.factorList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["echart-btn", { active: _unref(selectFactor).factorCode === item.factorCode }]),
                onClick: ($event: any) => (select(item))
              }, _toDisplayString(item.factorName), 11, _hoisted_17))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass(["echart-btn", { active: _unref(echartTime) === 'H' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (select('H')))
            }, " 时均值 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["echart-btn", { active: _unref(echartTime) === 'D' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (select('D')))
            }, " 日均值 ", 2),
            _createVNode(_component_n_date_picker, {
              value: _unref(startTime),
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(startTime) ? (startTime).value = $event : null)),
              size: "small",
              type: "date",
              clearable: "",
              "on-update:formatted-value": changeTime
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(AutoMonitor, {
            ref_key: "autoMonitor",
            ref: autoMonitor
          }, null, 512)
        ])
      ])
    ]),
    _createVNode(StationPhotoDialog, {
      ref_key: "stationDialog",
      ref: stationDialog
    }, null, 512)
  ]))
}
}

})